import React from 'react';

const Kentucky = () => {
  return (
    <div>
      
    </div>
  );
}

export default Kentucky;
